import React from 'react';

import { useTranslate } from '../../translate/I18n';
import useAsyncLoad from '../../hooks/useAsyncLoad';
import { getStages } from '../../store/partners/partners.service';

import Box from '../atoms/Box';
import Text from '../atoms/Text';
import PartnerForPublicUser from '../community/PartnerForPublicUser';
import { bool, string } from 'prop-types';
import SanitizedHTML from '../elements/SanitizedHTML';

const CommunityPublicPartner = ({ id, noFollow }) => {
  const { t } = useTranslate([`communityPartners_${id}`]);

  const pathToPartnerTranslation = `communityPartners_${id}:public`;
  const logoFilePath = t(`${pathToPartnerTranslation}:logoFilePath`);
  const description = t(`${pathToPartnerTranslation}:description`);
  const link = t(`${pathToPartnerTranslation}:link`);
  const ctaLabel = t(`${pathToPartnerTranslation}:ctaLabel`);

  return <PartnerForPublicUser {...{ camelCaseName: id, logoFilePath, description, link, noFollow, ctaLabel }} />;
};

CommunityPublicPartner.propTypes = {
  id: string,
  noFollow: bool
};

// eslint-disable-next-line react/prop-types
export const Partners = ({ preloadedStages = null }) => {
  const { isLoading, result: stages } = useAsyncLoad(async () => {
    if (preloadedStages === null) {
      return await getStages();
    }
    return preloadedStages;
  }, [preloadedStages]);
  const { t } = useTranslate(['common', 'partners']);

  if (isLoading) return null;

  return (
    <Box mx={{ _: 4, lg: 4, xl: 'auto' }} maxWidth="1280px">
      <Text tag="h1" styleName="wH2" mt={8}>
        {t('partners:title')}
      </Text>
      <Text tag="div" my={2}>
        <SanitizedHTML content={t('partners:details')} />
      </Text>
      <Box display="flex" flexWrap="wrap">
        {(stages || []).map(stage => (
          <Box key={stage.name} width={{ xl: '25%', lg: '50%', md: '50%', sm: '100%' }} minWidth="320px">
            <Box m={2}>
              <Text tag="h3" styleName="wH3" textAlign="center" mb={2}>
                {t(`partners:${stage.name}`)}
              </Text>
              {(stage.partners || []).map(({ id, noFollow }) => (
                <CommunityPublicPartner key={id} id={id} noFollow={noFollow} />
              ))}
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default Partners;
